export const VIEWS = {
  VIEW_LOADING: 0,
  VIEW_LOGIN: 1,
  VIEW_DASH: 2,
  VIEW_DETALHE: 3
}